// --- CLEAN + FIXED VERSION --- //

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { query, where, collection, onSnapshot, getDocs } from "firebase/firestore";
import logo_default from "../../assets/logo_default.jpg";
import banner_default from "../../assets/banner_default.jpg";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
 import Journal_voucher_entry from "./journal_voucher_entry.jsx";
 import Payment_voucher from "./payment_voucher.jsx";
 import Stock_voucher_entry from "./stock_voucher_entry.jsx";
import "./voucher_entry.css"; 
export const seo = {
    title: "aooz Services | Free & Premium Online Tools",
    description: "Discover free & premium online services on aooz.",
    keywords: "tools, seo, utilities",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

// -----------------------
// FORMAT 13 DIGIT ACCOUNT NUMBER
// -----------------------
export function formatAccountNumber(num, length = 13) {
    if (!num) return "";
    return String(num).padStart(length, "0");
}

export default function Voucher_entry() {
    const location = useLocation();
    const navigate = useNavigate();
    const { Toastshow } = Toast(); 
    const servicetablename = "accountingfinancedb";
    const [slug, setSlug] = useState("");
    const [voucherdate, setVoucherdate] = useState(""); 
    const select_company_uid = Cookies.get("select_company_uid");

    // -----------------------
    // SET DATE
    // -----------------------
    useEffect(() => {
        setVoucherdate(new Date().toLocaleString());
    }, []);

    // -----------------------
    // GET SLUG FROM URL
    // -----------------------
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const s = params.get("slug");
        if (s && s !== "null") setSlug(s);
    }, [location.search]);
 
    // -----------------------
    // ESCAPE KEY → BACK
    // -----------------------
    // useEffect(() => {
    //     const handle = (e) => e.key === "Escape" && navigate(-1);
    //     window.addEventListener("keydown", handle);
    //     return () => window.removeEventListener("keydown", handle);
    // }, []);

 
    // ----------------------------------------------------
    return (
  <div>
  {slug === "journal_voucher" ? (
    <Journal_voucher_entry slug={slug} />
  ) : slug === "stock_voucher" ? (
    <Stock_voucher_entry slug={slug} />
  ) : (
    <Payment_voucher slug={slug} />
  )}
</div>
    );
}
